<template>
    <footer class="footer has-cards">
        
        <div class="container">
            
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; 2018 TeamStatus i. G.
                    </div>
                </div>
                
            </div>
        </div>
    </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
